import { store } from '@/store'
import { authorities } from '@/constants/authorities'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'

export default async function (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext
) {
  try {
    await store.dispatch('session/restoreStudioSession', { from, to })
    const userAuthorities = store.state.session?.userAuthorities || []

    if (!userAuthorities.includes(authorities['ADMIN_TOOL_AUTHORITY'])) {
      return next({ name: 'home' })
    }

    return next()
  } catch {
    return next({ name: 'getstarted' })
  }
}
